import { isEmpty } from '@app/utils/isEmpty';
import { Id, Product } from '@typings';
import { createSelector } from 'reselect';

export const getProductFilters = (state: Store) => state.products.filters;

export const getFilteredDelwinIds = (state: Store) => state.products.filters.deliveryWindows;

export const getCurrentOrDefaultProductSortingValue = (state: Store) => {
  const currentSorting = state.products.sorting;
  const defaultSorting = state.config.data.productSorting.default;

  return currentSorting ?? defaultSorting;
};

export const getLoadingProducts = (state: Store) => state.products.loadingProducts;

export const getIsProductLoading = (productId: string) =>
  createSelector(getLoadingProducts, loadingProducts => loadingProducts.includes(productId));

export const getIsAnyProductLoading = (state: Store) => !isEmpty(getLoadingProducts(state));

export const getProducts = (state: Store): Record<string, Product.Full> => {
  return state.products.products;
};

export const getProductDetailsById = (state: Store, id: Id) => getProducts(state)[id];

export const getStockTypeFilter = (state: Store) => {
  return getProductFilters(state).stockType;
};
export const getProductsExpandedFiltersStates = (state: Store) => state.products.expandedFilters.states;
